import { loc } from "../i18n/survey";

enum BusyLevel {
  NoTime = 'NoTime',
  FairlyBusy = 'FairlyBusy',
  NotBudy = 'NotBusy',
  Flexible = 'Flexible',
}

const busyLevelQuestion = {
  name: 'busyLevel',
  title: loc("quiz.busyLevel.title"),
  description: loc("quiz.busyLevel.description"),
  type: 'radiogroup',
  choices: [
    {
      value: BusyLevel.NoTime,
      text: loc("quiz.busyLevel.choices.noTime"),
    },
    {
      value: BusyLevel.FairlyBusy,
      text: loc("quiz.busyLevel.choices.fairlyBusy"),
    },
    {
      value: BusyLevel.NotBudy,
      text: loc("quiz.busyLevel.choices.notBusy"),
    },
    {
      value: BusyLevel.Flexible,
      text: loc("quiz.busyLevel.choices.flexible"),
    },
  ],
  isRequired: true,
}

export {
  BusyLevel,
  busyLevelQuestion,
}